module.exports = __webpack_public_path__ + "img/asanbazar.7b3b0e6a.png";